import { render, staticRenderFns } from "./SetupModal.vue?vue&type=template&id=f867345c&"
import script from "./SetupModal.vue?vue&type=script&lang=ts&"
export * from "./SetupModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports